import ReactGA from 'react-ga';
import { hotjar } from 'react-hotjar';
import _ from 'lodash';
import { IUserDetails } from '../interfaces';
import GeneralUtils from '../GeneralUtils';
import runtimeEnv from '../runtime-env';

type ReactGaEventLabel = 'SCW' | 'REPORTING' | 'SPC';

const initializeUserStats = () => {
  if (runtimeEnv.ENV !== 'app') return;
  if (GeneralUtils.getCookieValue('INIT_USER_STATS')) return;

  const gaTrackingId = runtimeEnv.GA;
  const hotjarId = _.toNumber(runtimeEnv.HOTJAR_ID);
  const hotjarVersion = _.toNumber(runtimeEnv.HOTJAR_VERSION);

  const userDetailsFromCookie = GeneralUtils.getCookieValue('USER_DETAILS');
  if (!userDetailsFromCookie || typeof userDetailsFromCookie !== 'string') return;

  let userDetails: IUserDetails | null = null;
  try {
    userDetails = JSON.parse(userDetailsFromCookie) as IUserDetails;
  } catch {
    return;
  }
  if (!userDetails) return;

  ReactGA.initialize(`${gaTrackingId}`, {
    useExistingGa: false,
    gaOptions: {
      clientId: userDetails.tenantId,
      userId: userDetails.userId,
    },
  });
  hotjar.initialize(hotjarId, hotjarVersion);
  hotjar.identify('USER_ID', { userProperty: userDetails.userId });
  hotjar.identify('CLIENT_ID', { userProperty: userDetails.tenantId });
  GeneralUtils.appendCookie('INIT_USER_STATS', 'true');
};

const registerPageView = (history: any) => {
  if (runtimeEnv.ENV === 'app') {
    initializeUserStats();
    const userDetailsFromCookie = GeneralUtils.getCookieValue('USER_DETAILS');
    // const isUserStatsInit = GeneralUtils.getCookieValue('INIT_USER_STATS');
    if (userDetailsFromCookie) {
      // const userDetails:IUserDetails = JSON.parse(userDetailsFromCookie);
      ReactGA.set({ page: history.location.pathname });
      ReactGA.pageview(history.location.pathname);
      hotjar.stateChange(history.location.pathname);
    }
  }
};

const registerInteractionEvent = (interactionName: string, label: ReactGaEventLabel) => {
  if (runtimeEnv.ENV === 'app') {
    initializeUserStats();
    const userDetailsFromCookie = GeneralUtils.getCookieValue('USER_DETAILS');
    // const isUserStatsInit = GeneralUtils.getCookieValue('INIT_USER_STATS');
    if (userDetailsFromCookie) {
      ReactGA.event({
        category: 'Component Render',
        action: interactionName,
        label,
      });
      hotjar.event(`Component Render | ${interactionName} | ${label}`);
    }
  }
};

export default {
  registerPageView,
  initializeUserStats,
  registerInteractionEvent,
};
